import { render, staticRenderFns } from "./batch-disbursement-reference-detail.vue?vue&type=template&id=60f1c6a4&scoped=true"
import script from "./batch-disbursement-reference-detail.vue?vue&type=script&lang=js"
export * from "./batch-disbursement-reference-detail.vue?vue&type=script&lang=js"
import style0 from "./batch-disbursement-reference-detail.vue?vue&type=style&index=0&id=60f1c6a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f1c6a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f1c6a4')) {
      api.createRecord('60f1c6a4', component.options)
    } else {
      api.reload('60f1c6a4', component.options)
    }
    module.hot.accept("./batch-disbursement-reference-detail.vue?vue&type=template&id=60f1c6a4&scoped=true", function () {
      api.rerender('60f1c6a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/online-transaction/batch-disbursement-reference-detail.vue"
export default component.exports